<nav class="navbar navbar-expand-md navbar-light">
	<div class="title_export">Exports</div>
	<!-- <mat-nav-list class="inline">
		<a mat-list-item class="navbar-brand-tool menu pl-3 pr-3" [routerLink]="['/home']" [ngClass]="activeBoard? 'active' : ''">Dashboard</a>
	</mat-nav-list> -->

	<!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
		aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
		<span class="navbar-toggler-icon"></span>
	</button> -->

	<div class="menu-group collapse navbar-collapse" id="navbarSupportedContent">
		<mat-nav-list class="inline">
			<a mat-list-item class="navbar-brand-tool menu pl-3 pr-3" [routerLink]="['/home']" [ngClass]="activeBoard? 'active' : ''">Dashboard</a>
			<a mat-list-item [routerLink]="['/summary']" [ngClass]="highlightASN? 'active' : '' " class="menu">ASN</a>
			<a mat-list-item [routerLink]="['/shipments']" [ngClass]="highlightDocumentControl? 'active' : '' " class="menu">Document Control</a>
			<a mat-list-item [routerLink]="['/logs']" [ngClass]="highlightLOGS? 'active' : '' " class="menu">Logs</a>
		</mat-nav-list>
	</div>

</nav>